import React from 'react'

interface AdminLayoutProps {
  children: React.ReactNode
}

export const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen w-full">
      <div className="mx-auto px-2 py-4">
        {/* Main content area */}
        <div className="space-y-6">
          {children}
        </div>
      </div>
    </div>
  )
}
